import L from 'leaflet';

export default new L.Icon({
  iconUrl: '/icons/beach.svg',
  iconRetinaUrl: '/icons/beach.svg',
  iconAnchor: [0, 0],
  popupAnchor: [10, -5],
  iconSize: [20, 20],
  // shadowUrl: '/assets/marker-shadow.png',
  // shadowSize: [29, 40],
  // shadowAnchor: [7, 40],
});